import {observable, action} from 'mobx';
import priceSettings from './priceSettings.json'
import {finance} from "./index";


export default class FinanceData {
    @observable input;
    @observable drying;
    @observable cleaning;
    @observable storage;
    @observable output;
    @observable docsFee;

    constructor(){
        this.input = new DataDetailed('input');
        this.drying = new DataDetailed('drying');
        this.cleaning = new DataDetailed('cleaning');
        this.storage = new DataDetailed('storage');
        this.output = new DataDetailed('output');
        this.docsFee = new DataDetailed('docsFee');
    }


    incParams(param,culture,sum){
        this[param].incParam(culture,"cashYield",sum);
        this[param].incParam(culture,"directExpends",sum);
        this[param].incParam(culture,"indirectExpends",sum);
        this[param].incTotal(culture, sum);
    }

    incDCParams(param,culture,amount,variable){
        this[param].incParam(culture, "cashYield", variable * amount);
        this[param].incParam(culture, "directExpends", variable * amount);
        this[param].incParam(culture, "indirectExpends", amount);
        this[param].incTotal(culture,amount);
    }
}

class DataDetailed{
    @observable soy;
    @observable wheat;
    @observable rape;
    @observable sunflower;
    @observable corn;
    @observable total = {
        soy:0,
        wheat:0,
        rape:0,
        sunflower:0,
        corn:0,
    };


    constructor(elem = ''){
        this.elem = elem;
        this.wheat = {
            "cashYield":0,
            "directExpends":0,
            "indirectExpends":0
        };
        this.rape ={
            "cashYield":0,
            "directExpends":0,
            "indirectExpends":0
        };
        this.soy = {
            "cashYield":0,
            "directExpends":0,
            "indirectExpends":0
        };
        this.sunflower = {
            "cashYield":0,
            "directExpends":0,
            "indirectExpends":0
        };
        this.corn = {
            "cashYield":0,
            "directExpends":0,
            "indirectExpends":0
        };
    }

    @action incTotal(culture,inc){
        this.total[culture]+=inc;
    }

    @action incParam(culture,param,val){
        this[culture][param]+=val*priceSettings[param][this.elem][culture];
    }

}


// WEBPACK FOOTER //
// ./src/shared/stores/financeData.js